<template>
  <slot name="header_close" />
  <keep-alive>
    <component :is="`AddNumber${MESSENGERS[currentMsgr].title}Dialog`">
      <template v-slot:actions>
        <div class="content">
          <div class="social-button">
            <button
              v-for="msg in MESSENGERS"
              :key="msg.value"
              :class="[
                'btn',
                msg.value,
                { 'active-button': msg.value === currentMsgr },
              ]"
              @click="currentMsgr = msg.value"
            >
              <span :class="`icon icon-${msg.value}`" />
              <span class="btn-text"> «{{ msg.value }}» </span>
            </button>
          </div>
        </div>
      </template>
    </component>
  </keep-alive>
</template>

<script>
/* eslint-disable */
import AddNumberViberDialog from "./AddNumberViberDialog.vue";
import AddNumberTelegramDialog from "./AddNumberTelegramDialog.vue";
import AddNumberWhatsappDialog from "./AddNumberWhatsappDialog.vue";
import MessengerIconBase from "../../Icons/MessengerIconBase.vue";
import MESSENGERS from "@/data/messengers.js";

export default {
  components: {
    AddNumberViberDialog,
    AddNumberTelegramDialog,
    AddNumberWhatsappDialog,
    MessengerIconBase,
  },

  data() {
    return {
      currentMsgr: "viber",
      settings: {
        numberFalse: true,
      },
      MESSENGERS,
    };
  },
  computed: {
    isOpen() {
      return this.$store.state.isDialogOpen;
    },
  },
};
</script>
<!-- wasn't scoped in style -->
<style lang="scss" scoped>
.content {
  margin-top: 20px;

  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;
}

.social-button {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 10px;

  .btn {
    height: 55px;
    min-width: 190px;
    width: 32%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    background-color: transparent;
    font-family: Gilroy;
    font-size: 20px;
    font-weight: 700;

    text-transform: uppercase;

    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: 12px;

    &:hover {
      cursor: pointer;
    }
  }

  .icon {
    font-size: 44px;
    &-viber {
    }

    &-telegram {
      margin-right: -6px;
      margin-bottom: 6px;
    }

    &-whatsapp {
      display: flex;
      justify-content: center;
      margin-left: 2px;
    }
  }

  .viber {
    color: var(--viber-color);
    border-color: var(--viber-color);
  }

  .telegram {
    color: var(--telegram-color);
    border-color: var(--telegram-color);
  }

  .whatsapp {
    color: var(--whatsapp-color);
    border-color: var(--whatsapp-color);
  }
  .active-button {
    color: white;

    background-color: v-bind("MESSENGERS[currentMsgr].color");
    -webkit-box-shadow: -10px 8px 32px -5px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: -10px 8px 32px -5px rgba(0, 0, 0, 0.75);
    box-shadow: -10px 8px 32px -5px rgba(0, 0, 0, 0.75);

    span {
      color: white;
    }
    &.icon-whatsapp::before {
      color: white;
    }
  }
  span {
    letter-spacing: 1px;
  }
}

.number-add-second-frame,
.number-add-telegram-frame {
  width: auto !important;

  padding: 0 !important;

  & > .title {
    display: none;
  }
}

@media screen and (max-width: 700px) and (min-width: 580px) {
  .social-button {
    .btn {
      min-width: 160px;
      height: 45px;
      &-text {
        font-size: 16px;
        // font-size: 0;
        transition: font-size 0.3s ease-in-out;
      }
    }
    .icon {
      font-size: 30px;
      &-whatsapp {
        &::before {
          font-size: 18px;
          margin-top: 4px;
        }
      }
    }
  }
}

@media screen and (max-width: 580px) {
  .social-button {
    flex-direction: column;
    gap: 15px;
    .btn {
      justify-content: flex-start;
      width: 201px;
    }
  }
}

@media screen and (max-width: 480px) {
  .social-button {
    gap: 20px;
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
